import TrustPilotSlider from '../../components/trustPilotSlider/index';
export default TrustPilotSlider;